import script from "./TopMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopMenu.vue?vue&type=script&lang=ts&setup=true"

import "./TopMenu.vue?vue&type=style&index=0&id=266ac790&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266ac790"]])

export default __exports__